import React from 'react';
import './Footer.css'

function Footer() {
    const email = require('../assets/email.png')
    const phone = require('../assets/phone.png');
    const address = require('../assets/location.png');
    const timing = require('../assets/time.png');
    const fb = require('../assets/fb.png');
    const twitter = require('../assets/twitter.png');
    const yt = require ('../assets/youtube.png');

    return (
        <>
            <div className='footerDiv'>
                <div>
                    <h2>Contact Us:</h2>
                    <br />
                    <h3><img src={email}></img>info@petheaven.sg</h3>
                    <h3><img src={phone}></img>+65 1234 5678</h3>
                    <h3><img src={address}></img>123 Pet Street, Singapore 123456</h3>
                    <h3><img src={timing}></img>Mon-Fri, 10:00 AM - 05:00 PM</h3>
                </div>
                <div className='socialLinks'>
                    <h2>Social Media Links:</h2>
                    <br />
                    <h3><img src={fb}></img><a href="https://faecbook.com">Facebook</a></h3>
                    <h3><img src={twitter}></img><a href="https://twitter.com">Twitter</a></h3>
                    <h3><img src={yt}></img><a href="https://youtuube.com">Youtube</a></h3>
                </div>
            </div>
        </>
    )
}

export default Footer;